export default __webpack_public_path__ + "device_door_view_cam.88988f0b.png";